import styled from 'styled-components';

export const MyMessagePageContainer = styled.div`
    margin-top: 40px;

    table {
        border: 3px solid ${props => props.theme.accountMessagesTableColor};
    }

    td,
    th {
        border: none;
        display: table-cell;
        vertical-align: middle;
    }

    td {
        border-bottom: 2px ${props => props.theme.accountMessagestableColor} solid;
    }

    thead tr {
        background-color: ${props => props.theme.accountMessagesTableColor};
        text-transform: uppercase;
        height: 50px;
    }

    tbody tr {
        height: 70px;
    }

    .message-caption {
        margin: 25px 0;
        text-align: center;

        * + * {
            margin-left: 30px;
        }
    }

    .message-caption-block {
        display: inline-flex;
        align-items: center;
        margin-right: 15px;

        svg {
            max-width: initial;
        }

        p {
            margin: 0;
            padding: 0;
        }

        p {
            padding-left: 15px;
        }
    }

    .message-bottom {
        font-size: 10px;
        margin: 30px auto 0 auto;

        a {
            font-weight: ${props => props.theme.boldWeight};
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .hide-mobile {
            display: none !important;
        }

        th {
            padding: 0 5px;
            font-size: 11px;
        }

        th.state {
            text-align: center;
            width: 15%;
        }

        th.details {
            text-align: center;
        }

        th.reason {
            width: 30%;
        }

        td {
            font-size: 12px;
            padding: 0 5px;
        }

        td.reason {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        td.picto {
            text-align: center;
            padding: 0;

            div {
                justify-content: center;
            }
        }

        td.details {
            text-align: center;
        }

        .message-caption-block.center-mobile {
            margin-right: 0;
        }

        .message-caption {
            width: fit-content;
            margin: 0 auto;

            .message-caption-block {
                display: flex;
                margin: 0 0 10px;
                text-align: left;

                p {
                    vertical-align: top;
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/mymessages/MyMessagesPageStyle.js